module.exports = __webpack_public_path__ + "static/media/sg10sj.ebf7626b.png";